var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1236"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1236"
    },
    "bundlingPackage": "data-privacy-request-ui",
    "bundlingPackageVersion": "static-1.5781",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};